/**
 * 실명 대신 보일 닉네임 — 기본은 색깔 + 동물 (예: Teal Lynx). 합류할 때 무작위로 채우고 본인이 고칠 수 있다.
 */

const COLORS = [
  'Amber', 'Azure', 'Coral', 'Crimson', 'Cyan', 'Golden', 'Indigo', 'Ivory', 'Jade', 'Lavender',
  'Lemon', 'Lilac', 'Lime', 'Mint', 'Navy', 'Olive', 'Peach', 'Plum', 'Rose', 'Ruby',
  'Sage', 'Sapphire', 'Scarlet', 'Silver', 'Sky', 'Teal', 'Violet',
];

const ANIMALS = [
  'Badger', 'Bear', 'Beaver', 'Crane', 'Deer', 'Dolphin', 'Eagle', 'Falcon', 'Fox', 'Hedgehog',
  'Heron', 'Koala', 'Lynx', 'Marten', 'Otter', 'Owl', 'Panda', 'Penguin', 'Puffin', 'Rabbit',
  'Raccoon', 'Robin', 'Seal', 'Sparrow', 'Swan', 'Tiger', 'Turtle', 'Whale', 'Wolf', 'Wren',
];

export const NICKNAME_MAX = 30;

const pick = (list) => list[Math.floor(Math.random() * list.length)];

/** 무작위 닉네임 — 바로 앞과 같으면 한 번 더 뽑는다 */
export const randomNickname = (avoid = '') => {
  const next = `${pick(COLORS)} ${pick(ANIMALS)}`;
  return next === avoid ? `${pick(COLORS)} ${pick(ANIMALS)}` : next;
};
